export default class {

    constructor() {

        this.update();

        window.addEventListener(
            'resize',
            window._.debounce(() => { this.update(); }, 500)
        );

    }

    update() {

        this.width = window.innerWidth;
        this.height = window.innerHeight;
        this.media = this.breakpoint();

        window.EventHandler.fire('window-resized', {
            media: this.media,
            width: this.width,
            height: this.height
        });

    }

    breakpoint() {

        if (this.width > 1024) {
            return 'large';
        } else if (this.width > 640) {
            return 'medium';
        } else {
            return 'small';
        }

    }

    isOnScreen(element) {

        let wrapper = $(window),
            viewport = {
                top: wrapper.scrollTop(),
                left: wrapper.scrollLeft()
            },
            bounds = element.offset();

        viewport.right = viewport.left + wrapper.width();
        viewport.bottom = viewport.top + wrapper.height();

        bounds.right = bounds.left + element.outerWidth();
        bounds.bottom = bounds.top + element.outerHeight();

        return (!(viewport.right < bounds.left || viewport.left > bounds.right || viewport.bottom < bounds.top || viewport.top > bounds.bottom));

    }

}


// WEBPACK FOOTER //
// ./resources/js/src/core/ViewPort.js